<template>
  <tr class="product-attribute bg-gray-200 leading-tight">
    <td class="text-right w-1/3 md:w-1/4  p-2 pr-3 py-4">
      {{ label }}
    </td>
    <td class="font-mono font-bold">
      {{ value }}
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: 'Label'
    },
    value: {
      type: String,
      default: 'Value'
    }
  }
}
</script>

<style>

</style>
